import { inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { CanActivateFn, Router } from "@angular/router";
import { filter, map, take } from "rxjs";
import { MyPayrollStore } from "./stores/my-payroll.store";

export const myPayGuard: CanActivateFn = (_route, state) => {
  const store = inject(MyPayrollStore);
  const router = inject(Router);
  return toObservable(store.canAccessMyPay).pipe(
    filter((allowed): allowed is boolean => allowed !== undefined),
    take(1),
    map(allowed => allowed || router.createUrlTree(["/home/403-forbidden"], {
      queryParams: { returnUrl: state.url },
    })),
  );
};
